// 面板頁的通話卡（docs/panel/08-call-family；John 2026-10-22：網頁也能打給面板）：
//   - ［打給這台面板］：每個看得到面板頁的人（主人 / 家人）；撥出畫面在 PanelCallOverlay
//   - 自動接聽（只有主人）：GET /v3/panels/{id}/family 每位一個開關 → PUT settings {auto_answer_users}；
//     適合長輩不方便按接聽：對方打來響 10 秒後面板自動接通
import { useCallback, useEffect, useState, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { autoAnswerUsers, getPanelFamily, putPanelAutoAnswer, type PanelFamilyMember } from './panels';
import { panelCall } from './panelCall';

export function PanelCallCard({ panelId, panelName, isOwner }: { panelId: string; panelName: string; isOwner: boolean }) {
  const { t } = useTranslation();
  const call = useSyncExternalStore(panelCall.subscribe, panelCall.get);
  const [family, setFamily] = useState<PanelFamilyMember[] | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    if (isOwner) getPanelFamily(panelId).then(setFamily).catch(() => setFamily([]));
  }, [panelId, isOwner]);
  useEffect(load, [load]);
  const idle = call.phase === 'idle' || call.phase === 'ended';

  const toggle = async (userId: string) => {
    if (!family || busy) return;
    const next = family.map((m) => (m.user_id === userId ? { ...m, auto_answer: !m.auto_answer } : m));
    const prev = family;
    setFamily(next);
    setBusy(true);
    setMsg(null);
    try {
      await putPanelAutoAnswer(panelId, autoAnswerUsers(next));
      setMsg(t('panels.disp.saved'));
    } catch {
      setFamily(prev);   // 沒存到 → 還原
      setMsg(t('panels.errGeneric'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card" data-testid="panel-call-card">
      <button className="btn-primary" disabled={!idle} onClick={() => void panelCall.dial(panelId, panelName)} data-testid="panel-call-dial">
        {t('panelCall.dial')}
      </button>
      {isOwner && family && family.length > 0 && (
        <>
          <h3>{t('panelCall.autoTitle')}</h3>
          <p className="dv-detail-sub">{t('panelCall.autoHint')}</p>
          {family.map((m) => (
            <label key={m.user_id} className="dv-check" data-testid={`panel-auto-${m.user_id}`}>
              <input type="checkbox" role="switch" checked={m.auto_answer} disabled={busy} onChange={() => void toggle(m.user_id)} />
              {m.name}
            </label>
          ))}
        </>
      )}
      {msg && <p className="text-secondary">{msg}</p>}
    </div>
  );
}
